import { ActionTree } from "vuex";
import { RootState } from "../../store";
import { PlanTrailState } from "../PlanTrailModule";

// Import all action modules
import { undoRedoActions } from "./undo-redo";
import { saveShareActions } from "./save-share";
import { initializationActions } from "./initialization";
import { markerActions } from "./markers";
import { polylineActions } from "./polylines";
import { mapInteractionsActions } from "./map-interactions";
import { routeOperationsActions } from "./route-operations";
import { dayFlagActions } from "./day-flags";
import { fileOperationsActions } from "./file-operations";
import { multiRouteActions } from "./multi-route";
import { dragPreviewActions } from "./drag-preview";
import { stageConnectorActions } from "./stage-connectors";
import { stageDestinationActions } from "./stage-destinations";
import { routeJoinActions } from "./route-joins";
import { highlightActions } from "./highlights";
import { poiInteractionsActions } from "./poi-interactions";
import { routeValidationActions } from "./route-validation";
import { selectionActions } from "./selection";
import { controlPointSpacingActions } from "./controlPointSpacing";
import { cueActions } from "./cues";
import { mapMatchActions } from "./map-match";

// Import existing refactored actions
import refactoredActions from "../actions-refactored";

// Combine all actions into a single ActionTree
const actions: ActionTree<PlanTrailState, RootState> = {
  // Initialization actions
  ...initializationActions,

  // Undo/Redo actions
  ...undoRedoActions,

  // Marker management actions
  ...markerActions,

  // Polyline/LineString actions
  ...polylineActions,

  // Map interaction actions
  ...mapInteractionsActions,

  // Hand-added turn cues
  ...cueActions,

  // Admin map-matching of imported routes
  ...mapMatchActions,

  // Route operation actions
  ...routeOperationsActions,

  // Day flags: moving a night along the line, adding/removing days, spacing them
  ...dayFlagActions,

  // File operation actions
  ...fileOperationsActions,

  // Multi-route actions
  ...multiRouteActions,

  // Drag preview actions
  ...dragPreviewActions,

  // Stage connector actions
  ...stageConnectorActions,

  // Stage destination (attach to POI/waypoint/highlight) actions
  ...stageDestinationActions,

  // Joins between routes of the same day
  ...routeJoinActions,


  // Highlight actions
  ...highlightActions,
  
  // POI interaction actions
  ...poiInteractionsActions,
  
  // Route validation actions
  ...routeValidationActions,

  // Area selection actions
  ...selectionActions,

  // Evenly-spaced control point actions
  ...controlPointSpacingActions,

  // Save and share actions
  ...saveShareActions,

  // Include existing refactored actions
  ...refactoredActions
};

export default actions;
